const dataURLtoBlob = (dataURL) => {
    const [meta, b64] = dataURL.split(',');
    const mime = meta.match(/data:([^;]+);base64/i)?.[1] || 'application/octet-stream';
    const bin = atob(b64);
    const len = bin.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) arr[i] = bin.charCodeAt(i);
    return new Blob([arr], { type: mime });
}

const toBlob = (item) => {
    // Already a File/Blob
    if (item instanceof File || item instanceof Blob) return item;

    // Object with a .file dataURL (common pattern in UIs)
    if (item && typeof item === 'object' && typeof item.file === 'string' && item.file.startsWith('data:')) {
        return dataURLtoBlob(item.file);
    }

    // Raw dataURL string
    if (typeof item === 'string' && item.startsWith('data:')) {
        return dataURLtoBlob(item);
    }

    throw new Error('Unsupported file format for upload');
};

export default toBlob;